import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const ChikuWarimashi = props => {
  return <Dropdown.Static kubunKey='chiku_warimashi' {...props} />
}
